export default __webpack_public_path__ + "static/media/NewCodeBulkTemplate.56406ef2.xlsx";